import BoostHistory from './BoostHistoryView'
export default BoostHistory
